<template>
  <div>
    <h2>
      <span v-html="$t('login.forgot_your_password')"></span>
      <br>
      <span v-html="$t('login.forgot_your_password_desc')"></span>
    </h2>
    <form role="form">
      <div class="summary-errors alert alert-danger alert-dismissible" v-show="(errors.length > 0)">
        <ul>
          <li v-for="err in errors">{{err}}</li>
        </ul>
      </div>
      <fieldset>
        <div class="form-group">
          <input
            class="form-control"
            v-bind:placeholder="$t('login.user_name')"
            name="email"
            type="email"
            v-model="username"
            autofocus
          >
        </div>
        <div>
          <spin-button
            id="btnRetrieve"
            :css-class="'btn btn-login'"
            :button-text="$t('shared.buttons.submit')"
            :loading="isLoading"
            :loading-text="$t('login.login')"
            :onClick="retrievePassword"
          ></spin-button>
          <button
            type="button"
            class="btn btn-login"
            v-on:click="handleChangeComponentView('sign-in')"
          >{{$t('shared.buttons.cancel')}}</button>
        </div>
      </fieldset>
    </form>
  </div>
</template>
<script>
import AuthService from "@/services/AuthService";

export default {
  name: "forgot-password",
  data() {
    return {
      show: false,
      username: "",
      errors: [],
      isLoading: false
    };
  },
  methods: {
    handleChangeComponentView(name) {
      this.$emit("change-component-view", name);
    },
    retrievePassword() {
      let t = this;
      t.isLoading = true;
      AuthService.retrievePassword(this.username)
        .then(
          r => {},
          e => {
            this.errors = [];
            if (e.response.data.modelState) {
              for (var key in e.response.data.modelState) {
                for (
                  var i = 0;
                  i < e.response.data.modelState[key].length;
                  i++
                ) {
                  this.errors.push(e.response.data.modelState[key][i]);
                }
              }
            } else {
              this.errors.push(e.response.data.exceptionMessage);
            }
          }
        )
        .finally(() => {
          t.isLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue